import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LoadingComponent } from './components/loading/loading.component';
import { AlertComponent } from './components/alert/alert.component';
import { FormatCEPPipe } from './pipes/format-cep.pipe';
import { FormatCNPJPipe } from './pipes/format-cnpj.pipe';
import { OrderbyPipe } from './pipes/orderby.pipe';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarComponent } from './components/perfect-scrollbar/perfect-scrollbar.component';
import { ForceNativeScrollDirective } from './components/perfect-scrollbar/perfect-scrollbar-force-native-scroll.directive';
import { PerfectScrollbarDirective } from './components/perfect-scrollbar/perfect-scrollbar.directive';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClaimsModalComponent } from './components/claims-modal/claims-modal.component';
import { ConsultarPedidoModalComponent } from '../@core/components/consulta-pedido/consultar-pedido-modal/consultar-pedido-modal.component';
import { ChatAiComponent } from '../@core/components/chat-ai/chat-ai.component';

@NgModule({
  declarations: [
    HeaderComponent,
    NavbarComponent,
    LoadingComponent,
    AlertComponent,
    FormatCNPJPipe,
    FormatCEPPipe,
    OrderbyPipe,    
    PerfectScrollbarComponent,
    PerfectScrollbarDirective,
    ForceNativeScrollDirective,
    ClaimsModalComponent,
    ConsultarPedidoModalComponent,
    ChatAiComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgScrollbarModule,
    BsDropdownModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    HeaderComponent,
    NavbarComponent,
    LoadingComponent,
    AlertComponent,
    FormatCNPJPipe,
    FormatCEPPipe,
    OrderbyPipe,
    PerfectScrollbarComponent,
    PerfectScrollbarDirective,
    ForceNativeScrollDirective
  ]
})
export class ThemeModule { }
